import api from './api';

class StudentService {
  get_all_students2(filter_options) {
      return api.post(`/students/get`, filter_options);
  }
  get_student_filters() {
      return api.get(`/students/filters`);
  }
  get_student_enquetestatus(studentId) {
    if (studentId !== undefined) {
      return api.get(`/students/${studentId}/enquete`);
    }
    return api.get(`/students/enquete`);
  }
  refresh_student_enquetestatus(studentId) {
    if (studentId !== undefined) {
      return api.get(`/students/${studentId}/enqueteref`);
    }
    return api.get(`/students/enqueteref`);
  }
  resend_parent_auth(studentId) {
    if (studentId !== undefined) {
      return api.get(`/students/${studentId}/resend_parent_auth`);
    }
  }
  get_student_quick(searchterm) {
      return api.get(`/students/quick`, { params: {quick: searchterm}});
  }
  search_student_quick(searchterm) {
      return api.get(`/students/namesearch`, { params: {quick: searchterm}});
  }
  get_student_positive_health(studentId) {
    if (studentId !== undefined) {
      return api.get(`/students/${studentId}/ps_gez`);
    }
    return api.get(`/students/ps_gez`);
  }
  search_data_sharing_partners(query) {
    return api.get(`/data-sharing-partners/search`, {
      params: { query }
    });
  }
  get_student_data_sharing_partners(studentId) {
    if (studentId !== undefined) {
      return api.get(`/students/${studentId}/data-sharing-partners`);
    }
    return api.get(`/students/data-sharing-partners`);
  }
  create_student_data_sharing_partner(studentId, partner) {
    if (studentId === undefined) {
      throw new Error('studentId is required');
    }
    return api.post(`/students/${studentId}/data-sharing-partners`, {
      student_id: studentId,
      ...partner
    });
  }
  update_data_sharing_partner(partnerId, update) {
    if (partnerId === undefined) {
      throw new Error('partnerId is required');
    }
    return api.put(`/data-sharing-partners/${partnerId}`, update);
  }
  delete_data_sharing_partner(partnerId) {
    if (partnerId === undefined) {
      throw new Error('partnerId is required');
    }
    return api.delete(`/data-sharing-partners/${partnerId}`);
  }
  resendWelcome(studentId) {
    return api.get(`/students/${studentId}/welcomeme`);
  }
  create_students(students) {
      return api.post(`/students`, 
        students
      );
    }
    delete_student(studentId, reden) {
      return api.post(`/students/${studentId}/delete`, {reden})
    }

    get_student(studentId, detailed) {
      if (studentId !== undefined) {
        return api.get(`/students/${studentId}${detailed ? '/details' : ''}`);
      }
      return api.get(`/students/me`);
  }
  save_student(studentId, student){
    if (studentId !== undefined) {
      return api.post(`/students/${studentId}`, student);
    }
    return api.post(`/students/change`, student);

  }
  get_dossier(studentId){
    if (studentId !== undefined) {
      return api.get(`/students/${studentId}/dossier`);
    }
    return api.get(`/students/dossier`);
  }
  add_to_dossier(studentId, item){
    if (studentId !== undefined) {
      return api.post(`/students/${studentId}/dossier/add`, item);
    }
    return api.post(`/students/dossier/add`, item);
  }
  change_dossier(studentId, item){
    if (studentId !== undefined) {
      return api.post(`/students/${studentId}/dossier/edit`, item);
    }
    return api.post(`/students/dossier/edit`, item);
  }
  
  
  // get_tab(tabId, studentId) {
  //   if (studentId !== undefined) {
  //     return api.get(`/students/${studentId}/tabs/${tabId}`);
  //   }
  //   return api.get(`/students/tabs/${tabId}`);
  // }

  // create_students(submit_token, fields, status, studentId) {
  //   if (studentId !== undefined) {
  //     return api.post(`/students/${studentId}/submissions`, {
  //       submit_token,
  //       fields,
  //       status
  //     });
  //   }
  //   return api.post(`/students/submissions`, {
  //     submit_token,
  //     fields,
  //     status
  //   });
  // }
}

export default new StudentService();
